import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useElasticVsAlgoliaKeywordSearchExperiment = () => {
    const hasElasticVsAlgoliaKeywordSearchControl = useAmplitudeExperimentBase(
        AmplitudeExperiments.ElasticVsAlgoliaKeywordSearch,
        AmplitudeVariants.ElasticVsAlgoliaKeywordSearch.Control
    );

    const hasElasticVsAlgoliaKeywordSearchTreatment = useAmplitudeExperimentBase(
        AmplitudeExperiments.ElasticVsAlgoliaKeywordSearch,
        AmplitudeVariants.ElasticVsAlgoliaKeywordSearch.Treatment
    );

    return {
        hasElasticVsAlgoliaKeywordSearchControl,
        hasElasticVsAlgoliaKeywordSearchTreatment,
    };
};
